import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
// import logo from "../logo-wis.avif"; // Wisdom logo - commented for future use
import echoxborderLogo from "../EchoxborderLogo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faQuestionCircle,
  faBell,
  faEnvelope,
  faCog,
  faUser,
  faChevronDown,
  faSignOutAlt,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";

const GlobalHeader = ({ 
  title = "System Dashboard", 
  icon = faChevronDown, 
  actionButtons = null,
  showLogos = true,
  onRefresh = null,
  className = ""
}) => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  
  // State management for dropdowns
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div className={`w-full bg-white shadow-lg ${className}`}>
      <div className="bg-gradient-to-r from-[#1A2654] to-blue-700 text-white">
        {/* Corporate Menu Bar */}
        <div className="flex justify-end items-center px-6 py-2">
          <div className="flex items-center space-x-4 text-sm">
            <button className="text-blue-100 hover:text-white flex items-center">
              <FontAwesomeIcon icon={faQuestionCircle} className="mr-1" />
              <span>Help</span>
            </button>

            {/* Notifications dropdown */}
            <div className="relative dropdown-container">
              <button
                className="text-blue-100 hover:text-white flex items-center"
                onClick={() => {
                  setShowNotifications(!showNotifications);
                  setShowUserMenu(false);
                }}
              >
                <div className="relative">
                  <FontAwesomeIcon icon={faBell} />
                </div>
                <span className="ml-1">Notifications</span>
              </button>

              {showNotifications && (
                <div className="absolute right-0 mt-2 w-80 bg-white rounded-md shadow-lg overflow-hidden z-20 text-gray-800 dropdown-container">
                  <div className="py-2 px-3 bg-gray-100 border-b border-gray-200 flex justify-between items-center">
                    <span className="font-medium">Notifications</span>
                    <span className="text-xs text-blue-600 cursor-pointer hover:text-blue-800">
                      Mark all as read
                    </span>
                  </div>
                  <div className="max-h-96 overflow-y-auto">
                    <div className="px-4 py-6 text-center text-gray-500">
                      No new notifications
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Messages */}
            <button className="text-blue-100 hover:text-white flex items-center">
              <FontAwesomeIcon icon={faEnvelope} />
              <span className="ml-1">Messages</span>
            </button>

            {/* Settings */}
            <button className="text-blue-100 hover:text-white flex items-center">
              <FontAwesomeIcon icon={faCog} />
              <span className="ml-1">Settings</span>
            </button>

            {/* User menu dropdown */}
            <div className="relative ml-2 dropdown-container">
              <button
                className="flex items-center space-x-2 bg-blue-800 hover:bg-blue-900 px-3 py-1 rounded text-sm transition-colors duration-200"
                onClick={() => {
                  setShowUserMenu(!showUserMenu);
                  setShowNotifications(false);
                }}
              >
                <div className="h-6 w-6 rounded-full bg-blue-200 flex items-center justify-center text-blue-800">
                  <FontAwesomeIcon icon={faUser} size="xs" />
                </div>
                <span>System Admin</span>
                <FontAwesomeIcon icon={faChevronDown} size="xs" />
              </button>

              {showUserMenu && (
                <div className="absolute right-0 mt-1 w-48 bg-white rounded-md shadow-lg overflow-hidden z-20 text-gray-800 dropdown-container">
                  <div className="py-3 px-4 border-b border-gray-100">
                    <p className="text-sm font-medium">System Admin</p>
                    <p className="text-xs text-gray-500">
                      admin@echo.com
                    </p>
                  </div>
                  <div>
                    <a
                      href="#"
                      className="block px-4 py-2 text-sm hover:bg-gray-100"
                    >
                      <FontAwesomeIcon
                        icon={faUser}
                        className="mr-2 text-gray-500"
                      />
                      My Profile
                    </a>
                    <a
                      href="#"
                      className="block px-4 py-2 text-sm hover:bg-gray-100"
                    >
                      <FontAwesomeIcon
                        icon={faCog}
                        className="mr-2 text-gray-500"
                      />
                      Account Settings
                    </a>
                    <a
                      href="#"
                      onClick={handleLogout}
                      className="block px-4 py-2 text-sm border-t border-gray-100 hover:bg-gray-100 text-red-600"
                    >
                      <FontAwesomeIcon icon={faSignOutAlt} className="mr-2" />
                      Sign Out
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Main header with title and action buttons */}
        <div className="flex justify-between items-center px-6 pt-5 pb-16 relative">
          <div className="flex items-center space-x-3">
            <FontAwesomeIcon icon={icon} className="text-2xl" />
            <h1 className="text-2xl font-bold tracking-tight">
              {title}
            </h1>
          </div>
          
          {/* Action buttons area - customizable per page */}
          {actionButtons && (
            <div className="flex items-center space-x-4">
              {actionButtons}
            </div>
          )}

          {/* EchoxBorder Logo */}
          {showLogos && (
            <div className="absolute bottom-2 right-6 flex items-center">
              <img
                src={echoxborderLogo}
                alt="EchoxBorder logo"
                className="h-11 object-contain opacity-90"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GlobalHeader;